import convert from 'convert-units';

export const convertMeasurement = (value, from, to) => +convert(value).from(from).to(to).toFixed(2);
